import ajax from '@/utils/ajax'

/**
 * @module 数据中心接口
 */

 const BASE_URL = '/dataBoard'

// 获取销售指标和油品销售占比数据
export const saleData = (params) => ajax.post(`${BASE_URL}/saleData`, params)

// 获取销售指标数据走势
export const saleDateTrend = (params) => ajax.post(`${BASE_URL}/saleDateTrend`, params)

// 获取用户占比数据
export const getuserData = (params) => ajax.post(`${BASE_URL}/userData`, params)

// 营业额统计图
export const turnoverStatistics = (params) => ajax.post(`${BASE_URL}/turnoverStatistics`, params)

// 折线图
export const orderVolumeStatistics = (params) => ajax.post(`${BASE_URL}/orderVolumeStatistics`, params)
